__turbopack_context__.v({
  "chevron": "contributors-navigation-module__usWUHq__chevron",
  "container": "contributors-navigation-module__usWUHq__container",
  "contributorsPanel": "contributors-navigation-module__usWUHq__contributorsPanel",
  "letter": "contributors-navigation-module__usWUHq__letter",
  "letters": "contributors-navigation-module__usWUHq__letters",
  "more": "contributors-navigation-module__usWUHq__more",
  "pages": "contributors-navigation-module__usWUHq__pages",
  "thanks": "contributors-navigation-module__usWUHq__thanks",
});
